@use "../styles/defaults";

.po_info_container {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: none;
    flex-direction: row;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    font-family: Roboto, Arial, Helvetica, sans-serif;

    &.show_po {
        display: flex;
    }

    .personalize_overlay {
        position: relative;
        border-radius: 2px;
        padding: 20px 40px 20px 40px;
        max-height: 80vh;
        background-color: #fff;
        box-shadow: 0 3px 9px rgba(0,0,0,0.5);
        max-width: 450px;
        margin: auto;
        line-height: 1.5;
        box-sizing: border-box;

        .po_header {
            font-size: defaults.$default-header-font-size;
            font-weight: bold;
            line-height: 22px;
            letter-spacing: .75px;
            padding-bottom: 15px;
            margin-bottom: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #000;
            border-bottom: defaults.$default-border;

            .h_title {
                text-transform: uppercase;
                font-size: defaults.$default-header-font-size;
                font-weight: 700;
            }

            .h_cross_icon {
                width: 48px;
                height: 48px;
                cursor: pointer;
                border-radius: 28px;

                svg {
                    width: 48px;
                    height: 48px;

                    .es & {
                        fill: defaults.$lc-black;
                    }

                    .ring {
                        transition: fill 300ms;
                        fill: defaults.$lc-mid-grey;
                    }
                }

                &:hover svg .ring {
                    fill: defaults.$lc-black;

                    .es & {
                        fill: defaults.$lc-black;
                    }
                }
            }
        }

        .po_body {
            margin-bottom: 10px;
            font-size: defaults.$default-header-font-size;
            line-height: 19px;
            letter-spacing: .26px;
            max-height: 60vh;
            overflow-y: auto;
            color: defaults.$lc-black;
        }
    }
}
